import { useState, useEffect } from 'react'
import ThemeContext, { initialThemeState } from './themeContext'
import $ from 'jquery'

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(initialThemeState.theme)

  const localStorage = window.localStorage

  useEffect(() => {
    const savedThemeLocal = localStorage.getItem('globalTheme')

    if (savedThemeLocal) {
      setTheme(savedThemeLocal)
    }
  }, [])

  useEffect(() => {
    localStorage.setItem('globalTheme', theme)
  }, [theme])

  $(function () {
    if (theme === 'light') {
      $('body').addClass(`theme--${theme}`)
      $('body').removeClass('theme--dark')
    } else {
      $('body').removeClass('theme--light')
      $('body').addClass(`theme--${theme}`)
    }
  })

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <div className={`theme--${theme}`}>{children}</div>
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
